import { render, staticRenderFns } from "./task_newbie.vue?vue&type=template&id=d3ec977c&scoped=true"
import script from "./task_newbie.vue?vue&type=script&lang=ts"
export * from "./task_newbie.vue?vue&type=script&lang=ts"
import style0 from "./task_newbie.vue?vue&type=style&index=0&id=d3ec977c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3ec977c",
  null
  
)

export default component.exports